import React, { useState, useEffect } from "react";
import { FaSquareInstagram, FaXTwitter } from "react-icons/fa6";
import { FaFacebook, FaYoutube } from "react-icons/fa";
import { MdEmail, MdCall, MdLocationOn } from "react-icons/md";
import logo from "../images/logo.png";

export default function Footer() {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth >= 400 && windowWidth <= 480;

  const styles = {
    footer: {
      background: '#1e1e1e',
      color: '#ccc',
      padding: isMobile ? '30px 20px' : '40px 80px',
      fontFamily: 'Arial, sans-serif',
    },
    footerTop: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: isMobile ? '30px' : '40px',
      flexDirection: isMobile ? 'column' : 'row',
    },
    footerCol: {
      flex: 1,
      minWidth: isMobile ? '100%' : '200px',
      textAlign: isMobile ? 'left' : 'left',
    },
    brand: {
      display: 'flex',
      alignItems: 'center',
      fontSize: isMobile ? '18px' : '20px',
      fontWeight: 'bold',
      color: '#fff',
      marginTop: '10px',
      justifyContent: isMobile ? 'flex-start' : 'flex-start',
    },
    logo: {
      marginRight: '10px',
      width: isMobile ? '60px' : '80px',
      height: isMobile ? '60px' : '80px',
      objectFit: 'contain',
      marginTop: '-10px',
    },
    paragraph: {
      margin: isMobile ? '10px 0' : '15px 0',
      lineHeight: 1.5,
      fontSize: isMobile ? '14px' : 'inherit',
    },
    socialIcons: {
      display: 'flex',
      gap: isMobile ? '20px' : '15px',
      fontSize: isMobile ? '20px' : '18px',
      color: '#ccc',
      justifyContent: isMobile ? 'flex-start' : 'flex-start',
      margin: isMobile ? '15px 0' : '0',
    },
    socialIcon: {
      cursor: 'pointer',
      transition: 'color 0.3s ease, transform 0.2s ease',
      '&:hover': {
        color: '#39d353',
        transform: 'scale(1.1)',
      },
    },
    heading: {
      fontSize: isMobile ? '18px' : '16px',
      color: '#fff',
      marginBottom: isMobile ? '15px' : '10px',
    },
    list: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      textAlign: isMobile ? 'left' : 'left',
    },
    listItem: {
      marginBottom: isMobile ? '12px' : '8px',
      fontSize: isMobile ? '14px' : 'inherit',
    },
    navLink: {
      cursor: 'pointer',
      transition: 'color 0.3s ease',
      '&:hover': {
        color: '#39d353',
      },
    },
    locationItem: {
      marginBottom: isMobile ? '12px' : '8px',
      cursor: 'default',
      transition: 'color 0.3s ease',
      '&:hover': {
        color: '#39d353',
      },
      fontSize: isMobile ? '13px' : 'inherit',
      lineHeight: isMobile ? 1.4 : 'inherit',
    },
    icon: {
      marginRight: isMobile ? '6px' : '8px',
      verticalAlign: 'middle',
    },
    hr: {
      border: 'none',
      borderTop: '1px solid #555',
      margin: isMobile ? '25px 0' : '30px 0',
    },
    footerBottom: {
      textAlign: 'center',
      fontSize: isMobile ? '12px' : '14px',
      color: '#888',
    },
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.footerTop}>
        {/* Brand & Description */}
        <div style={styles.footerCol}>
          <h3 style={styles.brand}>
            <img
              src={logo}
              alt="FutureFitness Logo"
              style={styles.logo}
            />
            FutureFitness
          </h3>
          <p style={styles.paragraph}>
            Transforming lives through fitness excellence and innovative training
            methods. A Complete Family GYM.
          </p>
          <div style={styles.socialIcons}>
            <FaSquareInstagram 
              style={styles.socialIcon}
              onClick={() => window.open('https://www.instagram.com/futurefitness_gym_nellore/', '_blank')}
            />
            <FaFacebook 
              style={styles.socialIcon}
              onClick={() => window.open('https://www.facebook.com/FutureFitnessGYMNellore/', '_blank')}
            />
            <FaXTwitter 
              style={styles.socialIcon}
              onClick={() => window.open('https://x.com/futurefitnessg1', '_blank')}
            />
            <FaYoutube 
              style={styles.socialIcon}
              onClick={() => window.open('https://www.youtube.com/c/FUTUREFITNESSGYM/', '_blank')}
            />
          </div>
        </div>

        {/* Useful Links */}
        <div style={styles.footerCol}>
          <h4 style={styles.heading}>Useful Links</h4>
          <ul style={styles.list}>
            <li 
              style={{...styles.listItem, ...styles.navLink}} 
              onClick={() => scrollToSection('landingPage')}
            >
              Home
            </li>
            <li style={styles.listItem}>About Us</li>
            <li style={styles.listItem}>Shop</li>
            <li 
              style={{...styles.listItem, ...styles.navLink}} 
              onClick={() => scrollToSection('pricingSection')}
            >
              Membership
            </li>
            <li 
              style={{...styles.listItem, ...styles.navLink}} 
              onClick={() => scrollToSection('connectForm')}
            >
              Contact Us
            </li>
          </ul>
        </div>

        {/* Locations */}
        <div style={styles.footerCol}>
          <h4 style={styles.heading}>Locations</h4>
          <ul style={styles.list}>
            <li style={{...styles.listItem, ...styles.locationItem}}>Stonehousepet — 9640630404</li>
            <li style={{...styles.listItem, ...styles.locationItem}}>Harinathpuram — 9247040404</li>
            <li style={{...styles.listItem, ...styles.locationItem}}>Vanamthopu Center — 7799890404</li>
            <li style={{...styles.listItem, ...styles.locationItem}}>Current Office — 9640620404</li>
            <li style={{...styles.listItem, ...styles.locationItem}}>Vedayapalem — 7799710404</li>
            <li style={{...styles.listItem, ...styles.locationItem}}>BV Nagar — 7799720404</li>
            <li style={{...styles.listItem, ...styles.locationItem}}>Dhanalakshmi Puram — 9704734579</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div style={styles.footerCol}>
          <h4 style={styles.heading}>Contact Info</h4>
          <ul style={{...styles.list, ...styles.contactInfo}}>
            <li style={styles.listItem}>
              <MdEmail style={styles.icon} /> info@futurefitness.com
            </li>
            <li style={styles.listItem}>
              <MdCall style={styles.icon} /> 9640630404
            </li>
            <li style={styles.listItem}>
              <MdLocationOn style={styles.icon} /> Stonehousepet, Nellore
            </li>
          </ul>
        </div>
      </div>

      <hr style={styles.hr} />

      <div style={styles.footerBottom}>
        <p>© 2025 Future Fitness. All rights reserved</p>
      </div>
    </footer>
  );
}

